

/* tslint:disable */



export enum ObservationCategory {
    History = 0,
    VitalSigns = 1,
    Imaging = 2,
    Laboratory = 3,
    Procedure = 4,
    Survey = 5,
    Exam = 6,
    Therapy = 7,

}


